<template>
  <v-row class="d-flex reserve-time-selector mb-1">
    <v-col cols="12" class="pb-0">
      <v-select
        :loading="isLoading"
        :readonly="false"
        class="pa-3 d-flex align-center reserve-time"
        prepend-icon="$bell"
        append-icon="$chevronDownLight"
        v-model="reserveTime"
        placeholder="Arrivo tra"
        :items="easydriveOptions"
        item-text="text"
        item-value="value"
        hide-details
        single-line
        dense
        outlined
        :disabled="reserveTime != null"
        @change="setReserveTime"
      >
        <template v-slot:item="{ item }">
          <div class="w-100 reserve-time-hours">
            <v-list-item-content class="d-flex align-center">
              <span class="font-weight-bold">{{ item.value }}</span>
            </v-list-item-content>
          </div>
        </template>
      </v-select></v-col
    ></v-row
  >
</template>
<style lang="scss">
.v-list.v-select-list:has(.reserve-time-hours) {
  background-color: var(--v-secondary-base) !important;
  .v-list-item:not(:last-child) {
    border-bottom: 1px solid var(--v-grey-darken2) !important;
  }
}
.reserve-time-selector .v-text-field--outlined fieldset {
  border-color: transparent !important;
}
.reserve-time {
  width: 210px !important;
  height: 50px !important;
  .v-icon {
    color: $primary !important;
  }
  :deep(.v-input__slot) {
    height: 50px !important;
    display: flex;
    align-items: center;
    max-width: fit-content !important;
    padding: 0px !important;
    width: fit-content !important;
    .v-input__append-inner {
      margin: auto 0px !important;
    }
  }

  :deep(.v-input__control) {
    fieldset {
      border-color: transparent !important;
      border: none !important;
    }
    .v-select__slot {
      padding: 0 !important;
      max-width: 160px !important;
      width: fit-content !important;
    }
  }
}

.reserve-time-selector .v-input {
  background: $secondary !important;
  // font-size: 0.875rem !important;
}

.reserve-time-selector .v-input.v-input--is-disabled {
  background: var(--v-grey-lighten3) !important;
}

.reserve-time-selector {
  .v-input {
    ::placeholder,
    ::-webkit-input-placeholder,
    ::-ms-input-placeholder {
      color: $primary !important;
      font-weight: 600;
      text-transform: uppercase;
      font-size: 0.875rem !important;
    }
  }
}
</style>

<script>
//import OrderService from "~/service/orderService";
import { mapGetters } from "vuex";
import eurospinCustomService from "@/service/eurospinCustomService";
export default {
  name: "ReserveButton",
  props: { order: { type: Object, required: true } },
  components: {},
  mixins: [],
  data() {
    return {
      reserveTime: null,
      isLoading: false,
      isReadonly: false
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "cart/isAuthenticated"
    }),
    easydriveOptions() {
      return Object.values(this.$t("order.easydriveHours"));
    }
  },
  methods: {
    async setReserveTime() {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("access_token");
      this.isLoading = true;
      this.isReadonly = true;
      try {
        let result = null;
        if (this.isAuthenticated) {
          result = await eurospinCustomService.reservationParking(
            this.order,
            0,
            this.reserveTime
          );
        } else {
          result = await eurospinCustomService.reserveParking(
            this.order,
            0,
            this.reserveTime,
            token
          );
        }
        console.log("status", result.status);
        if (result) {
          this.isLoading = false;
          this.isReadonly = true;
          if (!result.success) {
            this.reserveTime = null;
            this.isReadonly = false;
          }
          // this.reserveTime = true;
        }
      } catch (err) {
        this.error = err.message;
        this.isLoading = false;
        this.isReadonly = false;
        this.reserveTime = null;
      } finally {
        this.isLoading = false;
      }
    },

    getReserveTime() {
      this.reserveTime = this.order?.orderInfos?.reservation_info?.split(
        ","
      )[0];
      // this.reserveTime = true;
      // this.reserveTime = 60;
    }
  },
  mounted() {
    this.getReserveTime();
  }
};
</script>
